/* Bazan PDP — shared progress thumb for carousel dots.
   - Reads scrollLeft on the track and sets --bz-thumb-pct on the dots element.
   - Loop-aware: khi track có clone (infinite carousel), pct tính theo vị trí trong
     MỘT chu kỳ card gốc (modulo cycle width) nên thumb chạy 0 -> 1 rồi wrap về 0
     đúng như card đang xem, thay vì kẹt ở scrollWidth của cả set clone.
   - Interactive: click / drag (pointer) trên strip để scrub carousel; arrow keys +
     Home/End cho keyboard.
   Legacy explicit pairs + generic auto-bind for `.bz-pslider__dots--soft`. */
(function () {
  'use strict';

  var LEGACY_PAIRS = [
    ['[data-bz-story-track]', '[data-bz-story-dots]'],
    ['[data-bz-ugc-track]', '[data-bz-ugc-dots]'],
    ['[data-bz-origin-track]', '[data-bz-origin-dots]'],
    ['[data-bz-rec-track]', '[data-bz-rec-dots]']
  ];

  function clamp01(v) {
    return v < 0 ? 0 : (v > 1 ? 1 : v);
  }

  function gapOf(track) {
    var st = window.getComputedStyle(track);
    return parseFloat(st.columnGap || st.gap) || 0;
  }

  /* Vị trí của el trong hệ toạ độ scroll của track (chính xác cả khi track/el
     không cùng offsetParent). */
  function scrollPosOf(el, track) {
    return el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
  }

  /* Card gốc đang hiển thị: bỏ clone ([data-bz-clone]) và item bị display:none
     (vd. recipes card của tab khác). */
  function origItems(track) {
    var out = [];
    var kids = track.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.nodeType !== 1) continue;
      if (k.hasAttribute('data-bz-clone')) continue;
      if (!k.offsetWidth) continue;
      out.push(k);
    }
    return out;
  }

  /* Metrics đo lại mỗi lần gọi — clone/tab/resize đều làm layout đổi. */
  function metrics(track) {
    var max = track.scrollWidth - track.clientWidth;
    var hasClones = !!track.querySelector('[data-bz-clone]');
    if (!hasClones) return { loop: false, max: max };
    var items = origItems(track);
    if (items.length < 2) return { loop: false, max: max };
    var first = items[0];
    var last = items[items.length - 1];
    var start = scrollPosOf(first, track);
    var end = scrollPosOf(last, track) + last.offsetWidth;
    var width = end - start + gapOf(track);
    if (!(width > 1)) return { loop: false, max: max };
    return { loop: true, start: start, width: width, max: max };
  }

  function stepOf(track) {
    var items = origItems(track);
    if (!items.length) return track.clientWidth;
    return items[0].offsetWidth + gapOf(track);
  }

  function bind(track, dots) {
    if (!track || !dots || dots._bzProgress) return;
    dots._bzProgress = true;

    function pctNow() {
      var m = metrics(track);
      if (m.loop) {
        var rel = ((track.scrollLeft - m.start) % m.width + m.width) % m.width;
        return clamp01(rel / m.width);
      }
      return m.max > 0 ? clamp01(track.scrollLeft / m.max) : 0;
    }

    function update() {
      var pct = pctNow();
      dots.style.setProperty('--bz-thumb-pct', pct.toFixed(4));
      dots.setAttribute('aria-valuenow', String(Math.round(pct * 100)));
    }

    /* ---- interaction ---- */

    dots.removeAttribute('aria-hidden');
    if (!dots.getAttribute('role')) dots.setAttribute('role', 'slider');
    if (!dots.getAttribute('tabindex')) dots.setAttribute('tabindex', '0');
    if (!dots.getAttribute('aria-label')) dots.setAttribute('aria-label', 'Carousel scroll position');
    dots.setAttribute('aria-valuemin', '0');
    dots.setAttribute('aria-valuemax', '100');
    dots.setAttribute('aria-orientation', 'horizontal');

    function thumbWidth() {
      var v = parseFloat(window.getComputedStyle(dots).getPropertyValue('--bz-thumb-w'));
      return (isFinite(v) && v > 0) ? v : 44;
    }

    function pctFromClientX(clientX) {
      var r = dots.getBoundingClientRect();
      if (!r.width) return 0;
      var tw = Math.min(thumbWidth(), r.width);
      var travel = Math.max(1, r.width - tw);
      return clamp01((clientX - r.left - tw / 2) / travel);
    }

    /* Set scrollLeft không animate. Loop: map pct vào đúng 1 chu kỳ card gốc,
       trừ 1px ở cuối để không vượt bound (vượt sẽ bị teleport về đầu giữa lúc kéo). */
    function scrubTo(pct) {
      var m = metrics(track);
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      if (m.loop) track.scrollLeft = m.start + pct * Math.max(0, m.width - 1);
      else track.scrollLeft = pct * m.max;
      track.style.scrollBehavior = prev;
      update();
    }

    function nudge(delta) {
      var m = metrics(track);
      var target = track.scrollLeft + delta;
      if (!m.loop) target = Math.max(0, Math.min(m.max, target));
      track.scrollTo ? track.scrollTo({ left: target, behavior: 'smooth' }) : (track.scrollLeft = target);
    }

    var dragging = false;

    function startDrag(e) {
      if (typeof e.button === 'number' && e.button !== 0) return;
      dragging = true;
      dots.classList.add('is-scrubbing');
      if (dots.setPointerCapture && e.pointerId != null) {
        try { dots.setPointerCapture(e.pointerId); } catch (err) {}
      }
      scrubTo(pctFromClientX(e.clientX));
      e.preventDefault();
    }
    function moveDrag(e) {
      if (!dragging) return;
      scrubTo(pctFromClientX(e.clientX));
      e.preventDefault();
    }
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      dots.classList.remove('is-scrubbing');
    }

    if (window.PointerEvent) {
      dots.addEventListener('pointerdown', startDrag);
      dots.addEventListener('pointermove', moveDrag);
      dots.addEventListener('pointerup', endDrag);
      dots.addEventListener('pointercancel', endDrag);
      window.addEventListener('pointerup', endDrag);
    } else {
      dots.addEventListener('mousedown', startDrag);
      window.addEventListener('mousemove', moveDrag);
      window.addEventListener('mouseup', endDrag);
      dots.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) startDrag({ clientX: e.touches[0].clientX, button: 0, preventDefault: function () { e.preventDefault(); } });
      }, { passive: false });
      dots.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0]) moveDrag({ clientX: e.touches[0].clientX, preventDefault: function () { e.preventDefault(); } });
      }, { passive: false });
      dots.addEventListener('touchend', endDrag);
    }

    dots.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowDown') { nudge(stepOf(track)); e.preventDefault(); }
      else if (k === 'ArrowLeft' || k === 'ArrowUp') { nudge(-stepOf(track)); e.preventDefault(); }
      else if (k === 'Home') { scrubTo(0); e.preventDefault(); }
      else if (k === 'End') { scrubTo(1); e.preventDefault(); }
    });

    /* ---- sync ---- */

    track.addEventListener('scroll', function () {
      if (dragging) return; // scrubTo đã update, tránh double-read giữa frame
      update();
    }, { passive: true });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(update, 120);
    });
    window.addEventListener('load', function () { setTimeout(update, 120); });
    update();
    setTimeout(update, 60);
    setTimeout(update, 400);
  }

  function findScrollTrack(section, exclude) {
    if (!section) return null;
    var explicit = section.querySelector('[data-bz-track]');
    if (explicit) return explicit;
    var all = section.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === exclude) continue;
      if (el.scrollWidth <= el.clientWidth) continue;
      var st = window.getComputedStyle(el);
      var ox = st.overflowX;
      if (ox === 'auto' || ox === 'scroll') return el;
    }
    return null;
  }

  function scan(root) {
    root = root || document;
    for (var i = 0; i < LEGACY_PAIRS.length; i++) {
      var pair = LEGACY_PAIRS[i];
      var tracks = root.querySelectorAll(pair[0]);
      for (var j = 0; j < tracks.length; j++) {
        var t = tracks[j];
        var section = t.closest('section') || t.parentNode;
        var d = section ? section.querySelector(pair[1]) : null;
        bind(t, d);
      }
    }
    var soft = root.querySelectorAll('.bz-pslider__dots--soft');
    for (var k = 0; k < soft.length; k++) {
      var dots = soft[k];
      if (dots._bzProgress) continue;
      var sec = dots.closest('section') || dots.parentNode;
      var track = findScrollTrack(sec, dots);
      if (track) bind(track, dots);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) scan(e.target);
  });
})();

// v=1788944431
